// extracted by mini-css-extract-plugin
export default {"loading_spinner":"LoadingSpinner_loading_spinner__GCnZf","spinner":"LoadingSpinner_spinner__Q1vlO","spin":"LoadingSpinner_spin__01Hjx"};